module.exports = new __parcel__URL__("machines_pirate_nation_wood_galleon_level_1.f29f7ff9.png").toString();